import * as React from "react";
import { stringToDom } from "./handleEmoji";

interface IProps {
  onMessageEmoji: (emoji: string) => void;
}

export default class ChatEmojiComponent extends React.Component<IProps, any> {
  constructor(props: IProps) {
    super(props);
    this.state = {
      emojiArr: [
        "哈哈",
        "可爱",
        "亲",
        "鬼脸",
        "呲牙",
        "大笑",
        "汗",
        "鲜花",
        "庆祝",
        "嘴唇",
        "强",
        "弱",
        "鼓掌",
        "加油"
      ]
    };
  }

  public chosenEmoji = (e: any) => {
    const em = `[${e.target.dataset.e}]`;
    this.props.onMessageEmoji(em);
  };

  public render() {
    const { emojiArr } = this.state;
    return (
      <div>
        <ul className="emoji__container--conetnt clerfix">
          {emojiArr.map((e: string, i: number) => {
            const img: any = stringToDom(`[${e}]`);
            return (
              <li key={i} data-emoji_code={`[${e}]`} onClick={this.chosenEmoji} data-e={e}>
                <p className="emoji__center--item" dangerouslySetInnerHTML={{ __html: img }} />
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pc/component/sidebar/component/InteractiveChatRoom/chatEmojiComponent.tsx